import { render, staticRenderFns } from "./catogoryList.vue?vue&type=template&id=b496bdc8&scoped=true&"
import script from "./catogoryList.vue?vue&type=script&lang=js&"
export * from "./catogoryList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b496bdc8",
  null
  
)

export default component.exports